import { useIntl } from 'react-intl';

import type { UseStudyPeriodSectionResult } from '../types';
import { useInheritedStudyPeriod } from './useInheritedStudyPeriod';

export const useStudyPeriodSection = (): UseStudyPeriodSectionResult => {
  const { formatMessage } = useIntl();
  const { startDate, endDate, isSet, inheritedFromCohortName, isLoading } =
    useInheritedStudyPeriod();

  return {
    sectionLabel: formatMessage({ id: 'analyticalDatasetDetail.studyPeriod.label' }),
    isSet,
    startDate,
    endDate,
    inheritedFromCohortName,
    dateRangeLabel: formatMessage({ id: 'analyticalDatasetDetail.studyPeriod.dateRangeLabel' }),
    notSetTitle: formatMessage({ id: 'analyticalDatasetDetail.studyPeriod.notSetTitle' }),
    notSetHint: formatMessage({ id: 'analyticalDatasetDetail.studyPeriod.notSetHint' }),
    isLoading,
  };
};
